<!-- Básica -->
<div class="row" *ngIf="isBasica">
  <!--
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 13,5 (%)</mat-label>
                                <input matInput id="txtRetPenTrMeioPrc" #txtRetPenTrMeioPrc maxlength="6"
                                    formControlName="retido_peneira_treze_meio_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtRetPenTrMeioPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_treze_meio_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 13 (%)</mat-label>
                                <input matInput id="txtRetPenTrPrc" #txtRetPenTrPrc maxlength="6"
                                    formControlName="retido_peneira_treze_prc" currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenTrPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_treze_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 12,5 (%)</mat-label>
                                <input matInput id="txtRetPenDzMeioPrc" #txtRetPenDzMeioPrc maxlength="6"
                                    formControlName="retido_peneira_doze_meio_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDzMeioPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_doze_meio_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 12 (%)</mat-label>
                                <input matInput id="txtRetPenDzPrc" #txtRetPenDzPrc maxlength="6"
                                    formControlName="retido_peneira_doze_prc" currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDzPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_doze_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">


                      <div class="col-lg col-md">
                        <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                            floatLabel="{{formFieldFloatLabel}}">
                            <mat-label class="InputLabelColor">Retido Peneira 11,5 (%)</mat-label>
                            <input matInput id="txtRetPenDzPrc" #txtRetPenDzPrc maxlength="6"
                                formControlName="retido_peneira_onze_meio_prc" currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}"  max="100">
                            <i matSuffix class="{{iconEnableField}}"></i>
                            <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                            </mat-hint>
                            <mat-hint align="end">{{txtRetPenDzPrc.value.length}} / 10</mat-hint>
                            <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_onze_meio_prc)}}
                            </mat-error>
                        </mat-form-field>
                    </div>


                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Vazado Peneira Corresp Oblongo (%)</mat-label>
                                <input matInput id="txtVazPenCorOblPrc" #txtVazPenCorOblPrc maxlength="6"
                                    formControlName="vazado_peneira_corresp_oblongo_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtVazPenCorOblPrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.vazado_peneira_corresp_oblongo_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
  -->
</div>

<!-- Comercial -->
<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
      <mat-card class="mat-elevation-z8 w-100">
          <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
              <div class="row">
                  <div class="col-lg col-md col-xs col-xl col-sm">
                      <p class="tituloLeft">{{step}}</p>
                  </div>
                  <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                      <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                          *ngIf="!collapseCard"></i>
                      <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                          *ngIf="collapseCard"></i>
                  </div>
              </div>
              <mat-card-content *ngIf="!collapseCard">

                  <div class="row pt-3">
                      <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 13,5 (%)</mat-label>
                              <input matInput id="txtRetPenTrMeioPrc" #txtRetPenTrMeioPrc maxlength="6"
                                  formControlName="retido_peneira_treze_meio_prc" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100"
                                  currencyMask [readOnly]="isReadOnlyRetidoPeneiraTrezeMeioPrc"
                                  [class.InputBlockColor]="isReadOnlyRetidoPeneiraTrezeMeioPrc">
                              <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRetidoPeneiraTrezeMeioPrc"></i>
                              <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRetidoPeneiraTrezeMeioPrc"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                              <mat-hint align="end">{{txtRetPenTrMeioPrc.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_treze_meio_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                      <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 13 (%)</mat-label>
                              <input matInput id="txtRetPenTrPrc" #txtRetPenTrPrc maxlength="6"
                                  formControlName="retido_peneira_treze_prc" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100"
                                  currencyMask [readOnly]="isReadOnlyRetidoPeneiraTrezePrc"
                                  [class.InputBlockColor]="isReadOnlyRetidoPeneiraTrezePrc">
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRetidoPeneiraTrezePrc"></i>
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRetidoPeneiraTrezePrc"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtRetPenTrPrc.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_treze_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                  </div>

                  <div class="row pt-3">
                      <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 12,5 (%)</mat-label>
                              <input matInput id="txtRetPenDzMeioPrc" #txtRetPenDzMeioPrc maxlength="6"
                                  formControlName="retido_peneira_doze_meio_prc" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100"
                                  currencyMask [readOnly]="isReadOnlyRetidoPeneiraDozeMeioPrc"
                                  [class.InputBlockColor]="isReadOnlyRetidoPeneiraDozeMeioPrc">
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRetidoPeneiraDozeMeioPrc"></i>
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRetidoPeneiraDozeMeioPrc"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtRetPenDzMeioPrc.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_doze_meio_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                      <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 12 (%)</mat-label>
                              <input matInput id="txtRetPenDzPrc" #txtRetPenDzPrc maxlength="6"
                                  formControlName="retido_peneira_doze_prc" currencyMask
                                  (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100"
                                  currencyMask [readOnly]="isReadOnlyRetidoPeneiraDozePrc"
                                  [class.InputBlockColor]="isReadOnlyRetidoPeneiraDozePrc">
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRetidoPeneiraDozePrc"></i>
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRetidoPeneiraDozePrc"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtRetPenDzPrc.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_doze_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                  </div>

                  <div class="row pt-3">


                    <div class="col-lg col-md">
                      <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                          floatLabel="{{formFieldFloatLabel}}">
                          <mat-label class="InputLabelColor">Retido Peneira 11,5 (%)</mat-label>
                          <input matInput id="txtRetPenDzPrc" #txtRetPenDzPrc maxlength="6"
                              formControlName="retido_peneira_onze_meio_prc" currencyMask
                              (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}"  max="100"
                              currencyMask [readOnly]="isReadOnlyRetidoPeneiraOnzeMeioPrc"
                              [class.InputBlockColor]="isReadOnlyRetidoPeneiraOnzeMeioPrc">
                            <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadOnlyRetidoPeneiraOnzeMeioPrc"></i>
                            <i matSuffix class="{{iconDisableField}}" *ngIf="isReadOnlyRetidoPeneiraOnzeMeioPrc"></i>
                          <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                          </mat-hint>
                          <mat-hint align="end">{{txtRetPenDzPrc.value.length}} / 10</mat-hint>
                          <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_onze_meio_prc)}}
                          </mat-error>
                      </mat-form-field>
                  </div>


                  <div class="col-lg-6 col-md-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Vazado Peneira Corresp Oblongo (%)</mat-label>
                        <input matInput id="txtVazPenCorOblPrc" #txtVazPenCorOblPrc maxlength="6"
                            formControlName="vazado_peneira_corresp_oblongo_prc" currencyMask
                            (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                        </mat-hint>
                        <mat-hint align="end">{{txtVazPenCorOblPrc.value.length}} / 10</mat-hint>
                        <mat-error>
                            {{hasErrorFormControl(formulario.controls.vazado_peneira_corresp_oblongo_prc)}}
                        </mat-error>
                    </mat-form-field>
                </div>
                  </div>
              </mat-card-content>
          </form>
      </mat-card>
  </div>
</div>

